import jsPDF from 'jspdf';
import 'jspdf-autotable';
import _ from 'lodash';
import moment from 'moment';

export const pointToPointTemplate = (data) => {
  let { challans, startDate, endDate } = data;
  console.log('da', data);

  let rows = [];
  let clientName = "";
  let entityId = "";
  let endAmt = 0;
  let endQty = 0;

  if (challans.length > 0) {
    clientName = challans[0].party.accountName;
    entityId = challans[0].entity;
  }
  let code = "";
  if (entityId === "62da46cf7eb6aa02db41297f") {
    code = `VO`;
  } else if (entityId === "62da46c57eb6aa02db41297d") {
    code = `IE`;
  } else {
    code = `Astra Lenses Eyecare`;
  }

  console.log('soumil final challans', challans)

  challans.forEach((o, index) => {
    let createdAt = o["createdAt"];
    let totalQuantity = 0;
    let totalAmount = 0;

    rows.push([
      '', `${moment(createdAt).format("DD-MM-YYYY")}`, // Format createdAt as needed
      `${o.code}`, ``, '', '', '', '', '', '', ''
    ]);

    totalAmount += Number(o.amount) || 0;
    const pkgCost = Number(o.packagingCost);
    // if (!Number.isNaN(pkgCost) && o.packagingCost != null && o.packagingCost !== "") {
    //   totalAmount += pkgCost;
    // }
    endAmt += totalAmount;

    o.items.forEach((i, id) => {
      let {
        quantity,
        codeR,
        codeL,
        nameL,
        nameR,
        rProductCode,
        lProductCode,
        isPrescriptionOrder,
        rateR,
        rateL,
        discountPercent,
        discountAmount,
        fittingAmount,
        tint,
        orderRef,
        amount,
        packagingCost,
      } = i;

      const qty = Number(quantity);
      const safeQty = Number.isNaN(qty) ? 0 : qty;
      totalQuantity += safeQty;
      endQty += safeQty;

      const safeCodeSuffix = (code) => {
        if (code == null || code === "") return "";
        const s = String(code);
        // Old behavior: show code without first 3 chars when present
        const trimmed = s.length > 3 ? s.slice(3) : s;
        return ` (${trimmed})`;
      };

      const displayNameR =
        (nameR != null && String(nameR).trim() !== "")
          ? String(nameR)
          : (isPrescriptionOrder ? (rProductCode ?? "") : "");

      const displayNameL =
        (nameL != null && String(nameL).trim() !== "")
          ? String(nameL)
          : (isPrescriptionOrder ? (lProductCode ?? "") : "");

      let row = [
        id > 0 ? '' : index + 1,
        // nameR && codeR ? `${nameR}` : '',
        displayNameR ? `${displayNameR}${safeCodeSuffix(codeR)}` : '',
        displayNameL ? `${displayNameL}${safeCodeSuffix(codeL)}` : '',
        orderRef,
        quantity != null && quantity !== '' ? quantity : (safeQty || ''),
        // For display: divide rateR and rateL by 2 if present
        rateR !== undefined && rateR !== null && rateR !== '' ? (Number(rateR) / 2).toFixed(2) : '',
        rateL !== undefined && rateL !== null && rateL !== '' ? (Number(rateL) / 2).toFixed(2) : '',
        discountPercent ? `${discountPercent}%` : discountAmount ? `Rs.${discountAmount}` : '',
        fittingAmount,
        tint,
        (Number(amount) != null && !Number.isNaN(Number(amount)) ? _.round(Number(amount), 2).toFixed(2) : '0.00')
      ];

      rows.push(row);

      if (id + 1 === o.items.length) {
        // Display packing charges when present
        const pkgCost = Number(o.packagingCost);
        if (!Number.isNaN(pkgCost) && pkgCost > 0) {
          rows.push([
            '', '', '', 'Packing charges', '', '', '', '', '', '', _.round(pkgCost, 2).toFixed(2)]);
        }
        
        const safeTotalAmt = Number.isNaN(totalAmount) ? 0 : totalAmount;
        rows.push([
          '', '', '', 'Total', totalQuantity, '', '', '', '', '', _.round(safeTotalAmt, 2).toFixed(2), 'special']);
        
      }
    });


  });

  const options = {
    orientation: "p",
    unit: "pt",
    format: "a4",  // Standard A4: 595pt × 842pt
    putOnlyUsedFonts: true,
  };

  const doc = new jsPDF(options);

  // ----- Header (avoid overlap by wrapping/stacking) -----
  const pageWidth = doc.internal.pageSize.getWidth();
  const marginX = 20;
  const headerTopY = 20;
  const lineH = 14;

  const msText = `M/S: ${clientName || ""}`;
  const msLines = doc.splitTextToSize(msText, pageWidth - marginX * 2);
  const titleText = `${code} Challan Summary`;
  const dateText =
    startDate && endDate
      ? `Date:${moment(startDate).format("DD/MM/YY")} to ${moment(endDate).format("DD/MM/YY")}`
      : "";

  // Compute a safe table startY so header never overlaps the table
  // Layout:
  // - M/S (wrapped)
  // - Title centered
  // - Date right-aligned (optional)
  const headerLinesCount =
    (msLines?.length || 1) + 1 + (dateText ? 1 : 0);
  const tableStartY = Math.max(40, headerTopY + headerLinesCount * lineH + 8);

  doc.autoTable({
    startY: tableStartY,
    margin: { left: marginX, right: marginX },
    head: [['Sr No.', 'Name R', 'Name L', 'Order Ref', 'Qty', 'Rate R', 'Rate L', 'Disc', 'Fitt Amt', 'Tint', 'Amount']],
    body: rows,
    styles: {
      fontSize: 10,
      cellPadding: 1.5,
      lineWidth: 0.1,
      lineColor: [0, 0, 0] // Black borders
    },
    theme: 'grid', // Grid format
    headStyles: {
      fillColor: [255, 255, 255], // White header background
      textColor: [0, 0, 0], // Black text color
      fontStyle: 'bold' // Bold text
    },
    bodyStyles: {
      fillColor: [255, 255, 255], // White body background
      textColor: [0, 0, 0] // Black text color
    },
    alternateRowStyles: {
      fillColor: [240, 240, 240] // Light grey for alternating rows
    },
    // Give Name columns more space than Order Ref so names don't get cut.
    // Widths are tuned for A4 portrait with default margins (~555pt usable width).
    columnStyles: {
      0: { cellWidth: 25 }, // Sr No.
      1: { cellWidth: 110, overflow: 'linebreak' }, // Name R
      2: { cellWidth: 110, overflow: 'linebreak' }, // Name L
      3: { cellWidth: 64, overflow: 'linebreak' }, // Order Ref
      4: { cellWidth: 28, halign: 'center' }, // Qty
      5: { cellWidth: 38, halign: 'right' }, // Rate R
      6: { cellWidth: 38, halign: 'right' }, // Rate L
      7: { cellWidth: 31, halign: 'center' }, // Disc
      8: { cellWidth: 38, halign: 'right' }, // Fitt Amt
      9: { cellWidth: 34, overflow: 'linebreak' }, // Tint
      10: { cellWidth: 39, halign: 'right' }, // Amount
    },
    didDrawCell: function (data) {
      // Check if the row has 'special' in the last cell of the last row
      if (data.row.index === rows.length - 1 && data.column.index === 10 && data.cell.raw === 'special') {
        // Modify the border thickness
        doc.setLineWidth(1.5); // Set thicker line width for the border
        doc.rect(data.cell.x, data.cell.y, data.cell.width, data.cell.height); // Draw a rectangle around the cell
        doc.setLineWidth(0.1); // Reset to default line width for other cells
      }
    },
    didDrawPage: function (data) {
      // Header only on first page
      if (data.pageCount === 1) {
        let y = headerTopY;

        doc.setFontSize(12);
        doc.setFont(undefined, "bold");
        // M/S (wrap)
        if (Array.isArray(msLines) && msLines.length > 0) {
          doc.text(msLines, marginX, y);
          y += msLines.length * lineH;
        } else {
          doc.text(msText, marginX, y);
          y += lineH;
        }

        // Title centered
        doc.setFontSize(13);
        doc.text(titleText, pageWidth / 2, y, { align: "center" });
        y += lineH;

        // Date right-aligned (optional)
        if (dateText) {
          doc.setFontSize(11);
          doc.setFont(undefined, "normal");
          doc.text(dateText, pageWidth - marginX, y, { align: "right" });
        }
      }
      // Footer
      let footerStr = `Page ${data.pageCount}`;
      doc.text(footerStr, data.settings.margin.left, doc.internal.pageSize.height - 10);
    }
  });

  // Total summary table
  const secondTableStartY = doc.lastAutoTable.finalY;
  doc.autoTable({
    showHead: "never",
    head: [['Sr No.', 'Name R', 'Name L', 'Order Ref', 'Qty', 'Rate R', 'Rate L', 'Disc', 'Fitt Amt', 'Tint', 'Amount']],
    body: [
      ['', '', '', '', '', '', '', '', '', `Total Qty:${Number.isNaN(endQty) ? 0 : endQty}`, `Balance: ${Number.isNaN(endAmt) ? 0 : Math.round(endAmt)}`]
    ],
    startY: secondTableStartY,
    startX: 5,
    styles: {
      fontStyle: 'bold',
      fontSize: 10,
      textColor: [0, 0, 0],
      lineColor: [0, 0, 0],
      fillColor: [255, 255, 255]
    },
    headStyles: {
      fontStyle: 'bold',
      cellPadding: 0.75,
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      valign: 'middle',
      lineColor: [0, 0, 0],
      fontSize: 10,
    },
    footStyles: {
      cellPadding: 0.75,
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      lineWidth: 0.05,
      lineColor: [0, 0, 0]
    },
    tableLineWidth: 0.1,
    tableLineColor: [0, 0, 0],
    columnStyles: {
      10: { halign: 'right' }, // Right align the last column (index 5)
      4: { halign: 'left' }
    }
  });


  const pdfBlob = doc.output('blob');

  // Open the PDF in a new browser tab
  const url = window.URL.createObjectURL(pdfBlob);
  window.open(url, '_blank');

  // Uncomment to save the PDF directly
  // return doc.save('point_to_point_template.pdf');
};
